var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ManagedApp as CoreManagedApp } from '@oceanjs/core';
import { useCallback } from 'react';
import { rootReducer } from '../../state/reducer';
import { LanguageProvider } from '../LanguageProvider';
/**
 * Entry point for the application
 */
export const ManagedApp = (props) => {
    const { children, reducer: reducerProp, defaultLocale, messages, customFormats } = props, otherProps = __rest(props, ["children", "reducer", "defaultLocale", "messages", "customFormats"]);
    const reducer = useCallback((state, action) => {
        const libState = rootReducer(state === null || state === void 0 ? void 0 : state.lib, action);
        if (reducerProp !== undefined) {
            const appState = reducerProp(state === null || state === void 0 ? void 0 : state.app, action);
            return { lib: libState, app: appState };
        }
        return { lib: libState };
    }, [reducerProp]);
    return (_jsx(CoreManagedApp, Object.assign({}, otherProps, { reducer: reducer }, { children: _jsx(LanguageProvider, Object.assign({ defaultLocale: defaultLocale, messages: messages, customFormats: customFormats }, { children: children }), void 0) }), void 0));
};
//# sourceMappingURL=ManagedApp.js.map